export default "__VITE_ASSET__CbI6aadg__"